export default __webpack_public_path__ + "static/media/no_pay_sheet_record.412d4ec1.png";